import React, { useRef, useState } from "react";
import styled from "styled-components";
import { Icon } from "@iconify/react";
import { Theme } from "../../themes/theme";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Label = styled.label`
  text-transform: uppercase;
  color: ${Theme.color.text.secondary};
  font-size: ${Theme.font.fontSize.xs};
  font-weight: ${Theme.font.fontWeight.medium};
  letter-spacing: ${Theme.font.letterSpacing.widest};
`;

const DropZone = styled.div`
  background: ${Theme.color.default.white};

  border: 1px dashed
    ${({ $dragging }) =>
      $dragging ? Theme.color.text.primary : Theme.color.border.light};

  border-radius: ${Theme.border.borderRadius.sm};

  padding: 14px;

  display: flex;
  align-items: center;
  gap: 16px;

  cursor: pointer;

  transition:
    border-color 0.15s ease,
    background 0.15s ease;

  &:hover {
    border-color: ${Theme.color.text.primary};
  }
`;

const UploadIcon = styled.div`
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${Theme.color.background.red};
  border-radius: ${Theme.border.borderRadius.sm};

  color: ${Theme.color.text.primary};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const UploadText = styled.p`
  font-size: ${Theme.font.fontSize.sm};

  line-height: ${Theme.font.lineHeight.relaxed};

  color: ${Theme.color.text.secondary};

  margin: 0;

  span {
    color: ${Theme.color.text.primary};
    font-weight: ${Theme.font.fontWeight.medium};
  }
`;

const FileText = styled.p`
  font-size: ${Theme.font.fontSize.xs};

  color: ${Theme.color.text.tertiary};

  margin: 0;
`;

const HiddenInput = styled.input`
  display: none;
`;

function FileDropZone() {
  const inputRef = useRef(null);

  const [dragging, setDragging] = useState(false);
  const [fileName, setFileName] = useState("");

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();

    setDragging(false);

    const file = e.dataTransfer.files?.[0];

    if (file) {
      setFileName(file.name);
    }
  };

  const handleChange = (e) => {
    const file = e.target.files?.[0];

    if (file) {
      setFileName(file.name);
    }
  };

  return (
    <Wrapper>
      <Label>Upload Drawing (Optional)</Label>
      <DropZone
        $dragging={dragging}
        onClick={() => inputRef.current?.click()}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
      >
        <UploadIcon>
          <Icon icon="tabler:upload" width={20} />
        </UploadIcon>

        <Content>
          <UploadText>
            <span>Click to upload</span> or drag & drop your file here
          </UploadText>

          <FileText>
            {fileName || "STEP, IGES, DXF, DWG, PDF — Max 20MB"}
          </FileText>
        </Content>

        <HiddenInput ref={inputRef} type="file" onChange={handleChange} />
      </DropZone>
    </Wrapper>
  );
}

export default FileDropZone;
